import { type WorkerRequirementsIncludedDocumentsType } from "@clipboard-health/contract-worker-app-bff";
import { isNil } from "@clipboard-health/util-ts";

export function shouldShowPendingReason(
  document: WorkerRequirementsIncludedDocumentsType | undefined
): boolean {
  if (isNil(document?.attributes)) {
    return false;
  }

  const { reviewedAt, notificationUpdatedAt, notification } = document.attributes;

  if (!reviewedAt || !notificationUpdatedAt || reviewedAt !== notificationUpdatedAt) {
    return false;
  }

  if (isNil(notification?.pushNotification)) {
    return false;
  }

  return notification.pushNotification;
}
